<template>
  <v-app dark class="tech-app-wrapper">
    <div class="circuit-overlay"></div>
    <vue-headful :title="title" />

    <v-container class="py-12 content-relative">
      
      <v-row justify="center" class="mb-16">
        <v-col cols="12" md="10" class="text-center">
          <div class="tech-header-container">
            <v-icon size="70" color="cyan accent-3" class="mb-4 glow-icon">mdi-console-network</v-icon>
            <h1 class="text-h3 font-weight-black white--text mb-2 text-uppercase neon-text tracking-widest">
              Centro de Datos:<br>Dominios
            </h1>
            <div class="subtitle-text cyan--text text--lighten-3 mono-font">
              > Inicializando protocolo de información general..._
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row justify="center" class="mb-16">
        <v-col cols="12" md="10">
          <v-hover v-slot="{ hover }">
            <v-card 
              class="rounded-lg overflow-hidden tech-card hologram-effect" 
              :elevation="hover ? 24 : 6"
            >
              <v-row no-gutters>
                <v-col cols="12" md="7" class="pa-8 d-flex flex-column justify-center z-index-2">
                  <div class="overline cyan--text font-weight-bold mb-2 mono-font">[:: DEFINICIÓN DEL SISTEMA ::]</div>
                  <h2 class="text-h4 font-weight-bold mb-4 white--text text-shadow-blue">
                    {{ dominios[0].titulo }}
                  </h2>
                  <p class="text-body-1 grey--text text--lighten-2" style="line-height: 1.8;">
                    {{ dominios[0].ptitulo }}
                  </p>
                </v-col>
                <v-col cols="12" md="5" class="network-bg d-flex align-center justify-center">
                  <v-icon size="180" color="cyan" class="network-icon opacity-50">mdi-access-point-network</v-icon>
                </v-col>
              </v-row>
              <div class="scan-line"></div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>

      <v-row justify="center" class="mb-16">
        <v-col cols="12" md="10">
          <div class="section-label mb-6">
             <v-icon left color="cyan">mdi-folder-network-outline</v-icon>
             <span class="mono-font cyan--text">CLASIFICACIÓN_GLOBAL.log</span>
          </div>

          <v-card class="rounded-lg tech-card overflow-hidden elevation-10">
            <v-tabs
              v-model="tab"
              background-color="transparent"
              color="cyan accent-3"
              centered
              grow
              height="70"
              class="tech-tabs"
            >
              <v-tab class="font-weight-bold white--text">
                <v-icon left small>mdi-earth</v-icon> Genéricos (gTLD)
              </v-tab>
              <v-tab class="font-weight-bold white--text">
                <v-icon left small>mdi-flag-variant-outline</v-icon> De País (ccTLD)
              </v-tab>

              <v-tab-item v-for="(item, i) in nivel" :key="'C' + i" class="tech-tab-content pa-8">
                  <v-row align="center">
                    <v-col cols="12" md="8">
                      <p class="text-h6 font-weight-light mb-0 white--text" style="line-height: 1.6;">
                        <span class="cyan--text font-weight-bold">></span> {{ item.contenido }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="4" class="text-right">
                      <div v-if="i === 0" class="d-flex flex-wrap justify-end">
                        <v-chip outlined color="cyan" class="ma-2 glow-chip mono-font">.COM</v-chip>
                        <v-chip outlined color="cyan" class="ma-2 glow-chip mono-font">.NET</v-chip>
                        <v-chip outlined color="blue" class="ma-2 glow-chip mono-font">.ORG</v-chip>
                      </div>
                      <div v-else class="d-flex justify-end align-center">
                         <div class="text-center mx-4">
                           <v-avatar color="cyan darken-4" size="60" class="elevation-10 neon-border mb-2">
                             <span class="white--text font-weight-black mono-font">.NI</span>
                           </v-avatar>
                           <div class="caption cyan--text">Local</div>
                         </div>
                         <div class="text-center mx-4 opacity-70">
                           <v-avatar color="grey darken-3" size="50" class="elevation-5 mb-2">
                             <span class="grey--text text--lighten-2 font-weight-bold mono-font">.ES</span>
                           </v-avatar>
                           <div class="caption grey--text">Externo</div>
                         </div>
                      </div>
                    </v-col>
                  </v-row>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" class="mb-10">
        <v-col cols="12" md="10">
          <v-row>
            <v-col cols="12" md="4" class="d-flex flex-column">
              <div class="server-rack-title pa-6 rounded-lg tech-card fill-height">
                <h3 class="text-h4 font-weight-black white--text mb-4 neon-text">MODULO:<br>JERARQUÍA</h3>
                <p class="cyan--text text--lighten-2 mono-font mb-6">
                  [INFO] Estructura de niveles de dominio y segmentación territorial.
                </p>
                <v-spacer></v-spacer>
                <v-icon size="120" color="blue accent-4" class="opacity-30 server-icon">mdi-server-network</v-icon>
              </div>
            </v-col>
            
            <v-col cols="12" md="8">
              <v-expansion-panels flat accordion v-model="panel" class="tech-panels">
                
                <v-expansion-panel class="mb-4 rounded-lg tech-card data-block">
                  <v-expansion-panel-header class="white--text text-h6 font-weight-bold py-6">
                    <template v-slot:default="{ open }">
                      <v-row no-gutters>
                        <v-col cols="12" class="d-flex align-center">
                          <v-icon :color="open ? 'cyan accent-3' : 'grey lighten-1'" class="mr-4">mdi-layers-triple</v-icon>
                          <span :class="{'cyan--text text--accent-3 text-shadow-blue': open}">Segundo Nivel (Global)</span>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="white--text pt-4">
                    <div class="data-readout mb-3 pl-4 border-left-cyan">
                      <strong class="cyan--text mono-font">>> .COM (Comercial):</strong><br> 
                      {{ tipos[0].info2.replace('.COM:', '') }}
                    </div>
                    <div class="data-readout pl-4 border-left-blue">
                      <strong class="blue--text text--lighten-2 mono-font">>> .ORG (Organizaciones):</strong><br>
                       {{ tipos[0].info3.replace('ORG:', '') }}
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel class="rounded-lg tech-card data-block">
                  <v-expansion-panel-header class="white--text text-h6 font-weight-bold py-6">
                     <template v-slot:default="{ open }">
                      <v-row no-gutters>
                        <v-col cols="12" class="d-flex align-center">
                          <v-icon :color="open ? 'cyan accent-3' : 'grey lighten-1'" class="mr-4">mdi-map-marker-path</v-icon>
                          <span :class="{'cyan--text text--accent-3 text-shadow-blue': open}">Tercer Nivel (Nacional .ni)</span>
                        </v-col>
                      </v-row>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="white--text pt-4">
                    <p class="text-body-1 grey--text text--lighten-2 mb-4">{{ tipos[2].info }}</p>
                    <div class="d-flex flex-wrap mt-3 terminal-output pa-4 rounded">
                      <span class="cyan--text mr-3 mono-font">root@nic:~# list domains</span><br>
                      <v-chip label small color="transparent" class="cyan--text mono-font mr-2 mb-2 border-cyan">.edu.ni</v-chip>
                      <v-chip label small color="transparent" class="cyan--text mono-font mr-2 mb-2 border-cyan">.gob.ni</v-chip>
                      <v-chip label small color="transparent" class="cyan--text mono-font mr-2 mb-2 border-cyan">.com.ni</v-chip>
                      <span class="blinking-cursor cyan--text">_</span>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-container>
  </v-app>
</template>

<script>
import vueHeadful from "vue-headful";

// NOTA: Asegúrate de que tu aplicación Vuetify esté configurada para soportar modo oscuro (dark: true en el objeto de opciones de Vuetify)
// o envuelve este componente en un <v-app dark> como he hecho aquí.

export default {
  components: {
    vueHeadful,
  },
  data() {
    return {
      title: "Información General | NIC",
      tab: null,
      panel: 0,
      // TUS DATOS ORIGINALES (Intactos)
      dominios: [
        {
          titulo: "¿Qué es un Dominio?",
          ptitulo: "Un dominio es un nombre único e inequívoco a nivel mundial para una región de Internet delimitada de forma lógica como, por ejemplo, una página web. El dominio, como parte fundamental de un Uniform Resource Locator (URL), señala dónde puede ser encontrado un recurso dentro del sistema jerárquico de nombres de dominio Domain Name System (DNS). La traducción de los nombres de dominio en direcciones IP se realiza a través de los llamados Nameserver.",
        },
      ],
      nivel: [
        {
          contenido: "Son considerados dominios genéricos (o gTLD) los dominios creados durante las primeras etapas del registro de dominios y que no están enfocados a un país en concreto, en este rango de tiempo fueron creados los dominios .com, .net y .org. Estos dominios se subastan sin ninguna restricción ni ningún tipo de requisito complejo.",
        },
        {
          contenido: "Un dominio de nivel superior geográfico o dominio de nivel superior de código de país (ccTLD) es un dominio de Internet usado y reservado para un país o territorio dependiente. Tienen una longitud de dos caracteres (ISO 3166-1). Cada país designa gestores para su ccTLD.",
        },
      ],
      tiposdominio: [{ titulo: "Tipos de Dominios" }],
      tipos: [
        {
          info2: ".COM: Se suele utilizar por Empresas y Organizaciones Comerciales de todo el mundo. Es el más utilizado actualmente.",
          info3: ".ORG: Lo deberían de utilizar sólo por instituciones sin ánimo de lucro y ONG.",
        },
        { info: "", info2: "" },
        {
          info: "Son los dominios del tipo por ejemplo: uni.edu.ni, cnu.edu.ni. Tienen la misma finalidad que los dominios de primer nivel pero con la territorialidad nicaragüense. Dominios .gob.ni, edu.ni. Organismos Públicos y Entidades e Instituciones relacionadas.",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* --- ESTILOS TECNOLÓGICOS / CYBERPUNK --- */

/* Fuentes y Utilidades */
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&display=swap');

.tech-app-wrapper {
  background-color: #050a14 !important; /* Fondo negro azulado muy oscuro */
  font-family: 'Montserrat', sans-serif;
  min-height: 100vh;
  position: relative;
}

.mono-font {
  font-family: 'Fira Code', monospace !important;
}

.tracking-widest {
  letter-spacing: 3px;
}

.z-index-2 {
  position: relative;
  z-index: 2;
}

.content-relative {
  position: relative;
  z-index: 3;
}

/* Fondo de Circuito Abstracto */
.circuit-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(0, 255, 255, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(41, 98, 255, 0.08) 0%, transparent 60%);
  background-size: cover;
  pointer-events: none;
  z-index: 1;
}
/* Patrón de rejilla sutil */
.circuit-overlay::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-image: 
      linear-gradient(rgba(0, 255, 255, 0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 30px 30px;
    z-index: -1;
}

/* Efectos de Texto y Neón */
.neon-text {
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5), 0 0 20px rgba(0, 255, 255, 0.3);
}

.text-shadow-blue {
  text-shadow: 0 2px 10px rgba(41, 98, 255, 0.5);
}

.glow-icon {
  filter: drop-shadow(0 0 8px rgba(0, 255, 255, 0.6));
}

/* Tarjetas Tecnológicas (Tech Cards) */
.tech-card {
  background: rgba(13, 25, 45, 0.85) !important; /* Fondo oscuro translúcido */
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 255, 255, 0.15) !important;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}

.tech-card:hover {
  border-color: rgba(0, 255, 255, 0.4) !important;
  box-shadow: 0 15px 40px -10px rgba(0, 255, 255, 0.2);
}

/* Tarjeta Holográfica Principal */
.hologram-effect {
  position: relative;
  border: 1px solid cyan !important;
  box-shadow: inset 0 0 20px rgba(0, 255, 255, 0.1), 0 0 15px rgba(0, 255, 255, 0.2) !important;
}

.network-bg {
  position: relative;
  overflow: hidden;
}
.network-bg::before {
  content: '';
  position: absolute;
  top: -50%; left: -50%; width: 200%; height: 200%;
  background: repeating-linear-gradient(transparent, transparent 5px, rgba(0, 255, 255, 0.05) 5px, rgba(0, 255, 255, 0.05) 10px);
  transform: rotate(45deg);
  animation: scanMove 20s linear infinite;
}

@keyframes scanMove {
  0% { transform: rotate(45deg) translateY(0); }
  100% { transform: rotate(45deg) translateY(100px); }
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: rgba(0, 255, 255, 0.5);
  box-shadow: 0 0 10px cyan;
  animation: scanDown 4s linear infinite;
  opacity: 0.7;
}

@keyframes scanDown {
  0% { top: -5%; opacity: 0; }
  20% { opacity: 0.7; }
  80% { opacity: 0.7; }
  100% { top: 105%; opacity: 0; }
}

/* Tabs Tecnológicos */
.tech-tabs .v-tab {
  letter-spacing: 1px;
  transition: 0.3s;
  opacity: 0.7;
}
.tech-tabs .v-tab--active {
  opacity: 1;
  text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
}
.tech-tab-content {
  background: rgba(13, 25, 45, 0.6);
  border-top: 1px solid rgba(0, 255, 255, 0.1);
}

.glow-chip {
  box-shadow: 0 0 8px rgba(0, 255, 255, 0.2);
}
.neon-border {
  border: 2px solid cyan;
  box-shadow: 0 0 10px rgba(0, 255, 255, 0.4);
}

/* Paneles de Datos (Accordion) */
.tech-panels .v-expansion-panel {
  background-color: transparent !important;
}

.data-block {
  border: 1px solid rgba(41, 98, 255, 0.2) !important;
  margin-bottom: 16px;
}

.data-block:hover {
  border-color: rgba(0, 255, 255, 0.5) !important;
}
.v-expansion-panel-header__icon .v-icon {
  color: cyan !important; /* Color de la flecha */
}

.border-left-cyan {
  border-left: 3px solid cyan;
}
.border-left-blue {
  border-left: 3px solid #2979FF;
}

/* Terminal Output */
.terminal-output {
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(0, 255, 255, 0.3);
}
.border-cyan {
   border: 1px solid cyan !important;
}

.blinking-cursor {
  font-weight: bold;
  animation: blink 1s step-end infinite;
}
@keyframes blink { 50% { opacity: 0; } }

/* Responsive adjustments */
@media (max-width: 960px) {
  .network-bg { min-height: 200px; }
  .network-icon { font-size: 120px !important; }
}
</style>